import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

interface PartnerCardProps {
  imageSrc: string;
  imageAlt: string;
  name: string;
  description: string;
}

export const PartnerCard = ({
  imageSrc,
  imageAlt,
  name,
  description,
}: PartnerCardProps) => {
  return (
    <Stack
      gap={{ sm: 4, lg: 8 }}
      alignItems={"center"}
      direction={{ sm: "column", lg: "row" }}
      paddingY={{ sm: 4, lg: 8 }}
      paddingX={{ md: 4 }}
      width={{ sm: "100%" }}
    >
      <Box
        sx={{ backgroundColor: "var(--mdai-dark-purple-2)", borderRadius: 2 }}
        width={{ sm: "100%", lg: "350px" }}
        minWidth={{ lg: "350px" }}
        height={"250px"}
        display={"flex"}
        justifyContent={"center"}
        alignItems={"center"}
      >
        <Box
          component={"img"}
          src={imageSrc}
          alt={imageAlt}
          m={"15%"}
          maxHeight={"100px"}
          maxWidth={"300px"}
        />
      </Box>
      <Stack
        maxWidth={{ sm: 800, lg: "100%" }}
        gap={4}
        alignItems={{ sm: "center", lg: "flex-start" }}
      >
        <Typography variant="h3">{name}</Typography>
        <Typography variant="body1" textAlign={{ sm: "center", lg: "left" }}>
          {description}
        </Typography>
      </Stack>
    </Stack>
  );
};
